import { q } from "../../helper/q"
import { closeOpenFilter } from "./filter"

export const catalogSorting = () => {
  const sortingElement = q(".productsFilterElementSort")
  const buttonElement = q(".productsFilterButtonSort", sortingElement)
  if (sortingElement) {
    buttonElement.addEventListener("click", () => {
      closeOpenFilter()
      if (sortingElement.classList.contains("productsFilterElementActive")) {
        closeOpenSorting()
        return null
      }
      sortingElement.classList.add("productsFilterElementActive")
      setTimeout(() => {
        q(".productsFilterParameters", sortingElement).style.opacity = 1
      }, 150)
    })
  }
}

export const closeOpenSorting = () => {
  const sortingElement = q(".productsFilterElementSort")
  q(".productsFilterParameters", sortingElement).style.opacity = 0
  sortingElement.classList.remove("productsFilterElementActive")
}
